import React from 'react';
import { ActiveElementRenderer } from 'live-lesson/shared/feature-call-ui-react';
import { Stack } from '@fluentui/react';
import {
    activeElementAndLocalPreviewTileStyles,
    horizontalContainerStyles,
} from '../../styles/ActiveElementAndLocalPreviewTile.styles';


const localPreviewTileContainerStyles = { aspectRatio: "16 / 9 ", maxWidth: '100%'};

const activeElementRendererStyles = {
    root: {
        aspectRatio: "16 / 9 ",       //"overflow: 'hidden'" on the 'ActiveElementAndLocalPreviewTile' element is required to make the height as the base side
        maxWidth: '100%',
    }
};

interface ActiveElementAndLocalPreviewTileProps {
    activeElement: null | HTMLElement;
    localPreviewTile?: React.JSX.Element;
}

export function ActiveElementAndLocalPreviewTile({ activeElement, localPreviewTile }: ActiveElementAndLocalPreviewTileProps): JSX.Element {

    return (
        <Stack.Item styles={activeElementAndLocalPreviewTileStyles}>
            <Stack verticalFill verticalAlign="center">
                <div className={horizontalContainerStyles.root}>
                    {/* creating two divs and align them horizontally */}
                    <div className={horizontalContainerStyles.localPreviewTile}>
                        <Stack.Item verticalFill style={localPreviewTileContainerStyles}>
                            {localPreviewTile}
                        </Stack.Item>

                    </div>
                    <div className={horizontalContainerStyles.activeElement}>
                        <ActiveElementRenderer
                            activeElement={activeElement}
                            styles={activeElementRendererStyles}
                        />
                    </div>
                </div>
            </Stack>
        </Stack.Item>
    );
}
